import { onlyDigit } from '@/functions/function.js';
import $ from 'jquery'

export default {
    name: 'ajout-consommable',
    components: {},
    props: [],
    data () {
        return {
            loading: false,
            loading_attribut: false,
            libelle: '',
            minimum: 0,
            optimale: 0,
            prix: 0,
            attributs: [],
            type: [],
            type_is_selected: false,
            lot_article: '',
            info_loading: false
        }
    },
    computed: {
        type_articles() {
            return this.$store.getters['types']
        },

        lot_article_ref_id() {
            return this.$store.getters['lot_article_ref_id']
        },

        article() {
            return this.$store.getters['article']
        },
    },

    mounted () {
        setTimeout(() => {
            $('.p-content').fadeIn();
        }, 500);

        this.$store.dispatch("getTypes");
        this.type= [];
        this.changeType(2);

        if (this.lot_article_ref_id) {
            this.selectArticle()
        }
    },
    methods: {
        selectArticle() {
            this.info_loading = true;
            const data = {
                month: "",
                one_date: this.setDates().today_date,
                from_date: "",
                to_date: "",
                article_id: this.lot_article_ref_id
            }
            this.$store.dispatch("getArticle", data).then(() => {
                this.libelle = this.article.libelle;
                this.minimum = this.article.minimum;
                this.optimale = this.article.optimale;
                this.prix = ""

                this.attributs = [];
                setTimeout(() => {
                    this.getAttributs()
                }, 600);
                
                this.info_loading = false;
            })
        },

        getAttributs() {
			for (let i = 0; i < this.type['attribut_articles'].length; i++) {
                let valeur = ''
                if (this.type['attribut_articles'][i].libelle == 'Prix cession') {
					valeur = ""
				} else {
					valeur = this.article.attribut[this.type['attribut_articles'][i].libelle]
				} 

                this.attributs.push({
                    valeur: valeur,
                    libelle: this.type['attribut_articles'][i].libelle,
					attribut: this.type['attribut_articles'][i].id
                });
			}
		},

        async changeType(id) {
            this.loading_attribut=true

            try {
                await this.$store.dispatch("getType",id)

                this.type= this.$store.getters['type']

                this.attributs= []

                let j = 0;
                for ( let i= 0; i<this.type['attribut_articles'].length ; i++) {
                    this.attributs.push({ valeur: [],  attribut: this.type['attribut_articles'][i].id });
                    j++;
                }
                if (j > 0) {
                    this.type_is_selected = true;
                }

                this.loading_attribut=false 
    
            } catch {
                this.loading_attribut=false 
            }
        },

        async submitForm() {

            const isValid = await this.$refs.observer.validate();
            if (isValid) {
                this.loading=true;

                const data = {
                    lot_article: this.lot_article,
                    libelle:  this.libelle,
                    prix: (this.prix != '')?this.prix:0,
                    minimum: (this.minimum != '')?this.minimum:0,
                    optimale: (this.optimale != '')?this.optimale:0,
                    type_article: 2,
                    attributs: this.attributs
                }

                this.$store.dispatch("saveArticle",data).then(
                    response => {
                        if (response) {
                            this.loading=true;
                            //this.$router.push({ path: `/medicaments/show/${response.id}` }) 
                            this.$router.push({ path: `/consommables` }) 
                        } else {
                            this.loading=false;
                        }
                    }
                );    
            }
            
        },

        /**
         * Authorise uniquement les chiffres
         * @param {*} input_id 
        */
        async allowOnlyDigit(input_id)
        {
            onlyDigit.onlyDigit(input_id)
        }
    }
}
  
  
  